(function () {
  if (window.__scubaCollectionEndlessScroll) return;
  window.__scubaCollectionEndlessScroll = true;

  var state = {
    root: null,
    results: null,
    grid: null,
    pagination: null,
    button: null,
    status: null,
    sentinel: null,
    controlsWrap: null,
    observer: null,
    nextUrl: "",
    loading: false,
    loadedPages: new Set(),
    loadedHandles: new Set()
  };

  function allowedPath() {
    var parts = window.location.pathname.replace(/\/$/, "").split("/").filter(Boolean);
    return parts.length === 2 && parts[0] === "collections" && ["all", "types", "vendors"].indexOf(parts[1]) === -1;
  }

  function label(name, fallback) {
    if (!state.root) return fallback;
    return state.root.getAttribute("data-scuba-endless-" + name) || fallback;
  }

  function normalisePageUrl(value) {
    var url = new URL(value, window.location.origin);
    var pairs = [];
    url.hash = "";
    url.searchParams.delete("section_id");
    url.searchParams.forEach(function (paramValue, paramName) {
      pairs.push([paramName, paramValue]);
    });
    pairs.sort(function (left, right) {
      return left[0] === right[0] ? left[1].localeCompare(right[1]) : left[0].localeCompare(right[0]);
    });
    var query = pairs.map(function (pair) {
      return encodeURIComponent(pair[0]) + "=" + encodeURIComponent(pair[1]);
    }).join("&");
    return url.pathname.replace(/\/$/, "") + (query ? "?" + query : "");
  }

  function sectionFetchUrl(value) {
    var url = new URL(value, window.location.origin);
    var sectionId = state.root ? state.root.getAttribute("data-section-id") : "";
    if (sectionId) url.searchParams.set("section_id", sectionId);
    return url.toString();
  }

  function getNextUrl(pagination) {
    if (!pagination) return "";
    var relNext = pagination.querySelector('a[rel="next"]');
    if (relNext && relNext.href) return relNext.href;
    var links = Array.prototype.slice.call(pagination.querySelectorAll("a[href]"));
    var nextLink = links.find(function (link) {
      return /next/i.test(link.textContent || "");
    });
    return nextLink ? nextLink.href : "";
  }

  function productHandle(card) {
    var link = card.querySelector('.product-block__title-link[href*="/products/"], .product-block__image[href*="/products/"], a[href*="/products/"]');
    if (!link) return "";
    var url = new URL(link.getAttribute("href"), window.location.origin);
    var parts = url.pathname.split("/").filter(Boolean);
    var productIndex = parts.indexOf("products");
    return productIndex >= 0 && parts[productIndex + 1] ? parts[productIndex + 1] : "";
  }

  function rememberVisibleProducts() {
    state.loadedHandles = new Set();
    Array.prototype.slice.call(state.grid.querySelectorAll(".product-block")).forEach(function (card) {
      var handle = productHandle(card);
      if (handle) state.loadedHandles.add(handle);
    });
  }

  function revealPagination() {
    if (!state.pagination) return;
    state.pagination.hidden = false;
    state.pagination.removeAttribute("aria-hidden");
  }

  function hidePagination() {
    if (!state.pagination) return;
    state.pagination.hidden = true;
    state.pagination.setAttribute("aria-hidden", "true");
  }

  function removeControls() {
    if (state.observer) state.observer.disconnect();
    if (state.controlsWrap && state.controlsWrap.parentNode) state.controlsWrap.parentNode.remove();
    state.observer = null;
    state.button = null;
    state.status = null;
    state.sentinel = null;
    state.controlsWrap = null;
  }

  function setLoading(isLoading) {
    state.loading = isLoading;
    if (!state.button) return;
    state.button.disabled = isLoading;
    state.button.textContent = isLoading ? label("loading", "Loading...") : label("load-more", "Load more");
  }

  function setStatus(message) {
    if (!state.status) return;
    state.status.textContent = message || "";
    state.status.hidden = !message;
  }

  function finish() {
    if (state.observer) state.observer.disconnect();
    state.loading = false;
    state.nextUrl = "";
    if (state.button && state.button.parentNode) state.button.parentNode.removeChild(state.button);
    state.button = null;
    setStatus(label("complete", "All products loaded."));
  }

  function controls() {
    var wrap = document.createElement("div");
    wrap.className = "scuba-endless-scroll large-row center";

    var button = document.createElement("button");
    button.type = "button";
    button.className = "btn btn--secondary";
    button.textContent = label("load-more", "Load more");
    button.addEventListener("click", loadNextPage);

    var status = document.createElement("p");
    status.className = "cc-filters-results__summary";
    status.setAttribute("aria-live", "polite");
    status.hidden = true;

    var sentinel = document.createElement("div");
    sentinel.setAttribute("aria-hidden", "true");

    wrap.appendChild(button);
    wrap.appendChild(status);
    wrap.appendChild(sentinel);
    state.pagination.parentNode.insertBefore(wrap, state.pagination.nextSibling);
    state.button = button;
    state.status = status;
    state.sentinel = sentinel;
    state.controlsWrap = wrap;
  }

  function parsePage(html) {
    var template = document.createElement("template");
    template.innerHTML = html;
    var nextResults = template.content.querySelector(".cc-filters-results");
    var nextGrid = nextResults ? nextResults.querySelector(".grid-flex.large-row") : null;
    var nextPagination = nextResults ? nextResults.querySelector(".pagination") : null;
    return {
      cards: nextGrid ? Array.prototype.slice.call(nextGrid.querySelectorAll(".product-block.grid-flex__item, .product-block")) : [],
      nextUrl: getNextUrl(nextPagination)
    };
  }

  function appendCards(cards) {
    var fragment = document.createDocumentFragment();
    var appended = 0;
    cards.forEach(function (card) {
      var handle = productHandle(card);
      if (!handle || state.loadedHandles.has(handle)) return;
      state.loadedHandles.add(handle);
      fragment.appendChild(card);
      appended += 1;
    });
    if (appended) state.grid.appendChild(fragment);
    if (window.lazySizes && window.lazySizes.autoSizer) window.lazySizes.autoSizer.checkElems();
    document.dispatchEvent(new CustomEvent("scuba:endless-scroll:loaded", { bubbles: true, detail: { appended: appended } }));
    return appended;
  }

  function loadNextPage() {
    if (state.loading || !state.nextUrl) return;
    var pageKey = normalisePageUrl(state.nextUrl);
    if (state.loadedPages.has(pageKey)) {
      finish();
      return;
    }

    setLoading(true);
    setStatus("");

    fetch(sectionFetchUrl(state.nextUrl), { method: "GET", credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("HTTP " + response.status);
        return response.text();
      })
      .then(function (html) {
        var parsed = parsePage(html);
        state.loadedPages.add(pageKey);
        appendCards(parsed.cards);
        state.nextUrl = parsed.nextUrl;
        if (!state.nextUrl) {
          finish();
        } else {
          setLoading(false);
        }
      })
      .catch(function () {
        setLoading(false);
        setStatus(label("error", "Could not load more products. Please use the pagination links."));
        revealPagination();
      });
  }

  function init() {
    removeControls();
    if (!allowedPath()) return;

    state.root = document.querySelector('[data-scuba-endless-scroll="standard-collection"][data-section-type="collection-template"]');
    if (!state.root) return;

    state.results = state.root.querySelector(".cc-filters-results");
    state.grid = state.results ? state.results.querySelector(".grid-flex.large-row") : null;
    state.pagination = state.results ? state.results.querySelector(".pagination") : null;
    state.nextUrl = getNextUrl(state.pagination);
    state.loadedPages = new Set([normalisePageUrl(window.location.href)]);

    if (!state.results || !state.grid || !state.pagination || !state.nextUrl) return;

    rememberVisibleProducts();
    controls();
    hidePagination();

    if ("IntersectionObserver" in window) {
      state.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadNextPage();
        });
      }, { rootMargin: "900px 0px 900px 0px", threshold: 0.01 });
      state.observer.observe(state.sentinel);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("filters-applied", function () {
    window.setTimeout(init, 0);
  });
}());
